import React from 'react';
import { Book, CheckCircle } from 'lucide-react';
const modules = [{
  num: '1',
  title: 'FUNDAMENTOS',
  desc: 'Base técnica completa + errores comunes',
  icon: '🎾'
}, {
  num: '2',
  title: 'NIVEL INICIAL',
  desc: 'Clases listas desde cero',
  icon: '📘'
}, {
  num: '3',
  title: 'NIVEL INTERMEDIO',
  desc: 'Evolución real de alumnos',
  icon: '📗'
}, {
  num: '4',
  title: 'SISTEMA DE PROGRESIÓN',
  desc: 'El secreto del progreso',
  icon: '📊'
}, {
  num: '5',
  title: 'PLANIFICACIÓN ANUAL',
  desc: 'Todo tu año organizado',
  icon: '🧠'
}, {
  num: '6',
  title: 'PROFESIONALIZACIÓN',
  desc: 'Convertite en un profe con sistema',
  icon: '💼'
}];
export function Modules() {
  return <section className="py-20 px-4 bg-[#0A1628]" data-id="element-181">
      <div className="max-w-6xl mx-auto" data-id="element-182">
        <h2 className="text-5xl md:text-6xl font-anton text-center mb-16 text-white" data-id="element-183">
          📦 LOS 6 MÓDULOS
        </h2>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 mb-16" data-id="element-184">
          {modules.map((mod, i) => <div key={i} className="bg-[#0F1F3D] border border-white/10 rounded-2xl p-8 hover:border-[#C6F432]/50 transition-colors group" data-id="element-185">
              <div className="text-4xl mb-4" data-id="element-186">{mod.icon}</div>
              <h3 className="text-xl font-bold text-[#C6F432] mb-2" data-id="element-187">
                MÓDULO {mod.num}
              </h3>
              <h4 className="text-2xl font-anton text-white mb-4" data-id="element-188">
                {mod.title}
              </h4>
              <p className="text-gray-300 font-medium" data-id="element-189">{mod.desc}</p>
            </div>)}
        </div>

        <div className="bg-gradient-to-r from-[#0F1F3D] to-[#0A1628] border border-[#C6F432]/30 rounded-2xl p-8 md:p-12 max-w-4xl mx-auto shadow-xl" data-id="element-190">
          <h3 className="text-2xl font-bold text-center mb-8" data-id="element-191">
            Cada módulo incluye:
          </h3>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4" data-id="element-192">
            <div className="flex items-center gap-3" data-id="element-193">
              <CheckCircle className="text-[#C6F432] shrink-0" data-id="element-194" />
              <span className="text-lg" data-id="element-195">
                Clase completa (inicio-desarrollo-cierre)
              </span>
            </div>
            <div className="flex items-center gap-3" data-id="element-196">
              <CheckCircle className="text-[#C6F432] shrink-0" data-id="element-197" />
              <span className="text-lg" data-id="element-198">Indicaciones claras</span>
            </div>
            <div className="flex items-center gap-3" data-id="element-199">
              <CheckCircle className="text-[#C6F432] shrink-0" data-id="element-200" />
              <span className="text-lg" data-id="element-201">Variantes por nivel</span>
            </div>
            <div className="flex items-center gap-3" data-id="element-202">
              <CheckCircle className="text-[#C6F432] shrink-0" data-id="element-203" />
              <span className="text-lg" data-id="element-204">Adaptación a grupos mixtos</span>
            </div>
            <div className="flex items-center gap-3 md:col-span-2 justify-center mt-2" data-id="element-205">
              <CheckCircle className="text-[#C6F432] shrink-0" data-id="element-206" />
              <span className="text-lg font-bold text-[#C6F432]" data-id="element-207">
                Aplicación inmediata
              </span>
            </div>
          </div>
        </div>
      </div>
    </section>;
}